import React, { useState } from 'react';

const StyleStep = ({ onComplete, onBack, initialAnswers }) => {
  const [selectedStyles, setSelectedStyles] = useState(
    initialAnswers?.styles || []
  );

  const styles = [
    {
      id: 'romantic',
      title: 'Romantic & lyrical',
      description: 'Flowing movements, soft port de bras, emotional storytelling, gentle expressiveness'
    },
    {
      id: 'playful',
      title: 'Playful & light',
      description: 'Quick footwork, charming character work, buoyant jumps, sparkling personality'
    },
    {
      id: 'fiery',
      title: 'Fiery & bold',
      description: 'Dramatic arms, passionate expression, strong stage presence, dynamic energy'
    },
    {
      id: 'powerful',
      title: 'Powerful & majestic',
      description: 'Grand movements, regal presence, commanding stage authority, noble bearing'
    }
  ];

  const handleToggleStyle = (styleId) => {
    if (selectedStyles.includes(styleId)) {
      setSelectedStyles(selectedStyles.filter(id => id !== styleId));
    } else if (selectedStyles.length < 2) {
      setSelectedStyles([...selectedStyles, styleId]);
    }
  };

  const handleNext = () => {
    if (selectedStyles.length > 0) {
      onComplete({ styles: selectedStyles });
    }
  };

  return (
    <div className="quiz-step">
      <h2>Which words best describe how you like to dance?</h2>
      <p>Choose up to 2 styles that resonate with your natural movement preferences.</p>
      
      <div className="multi-select-grid">
        {styles.map((style) => (
          <div
            key={style.id}
            className={`multi-select-card ${selectedStyles.includes(style.id) ? 'selected' : ''}`}
            onClick={() => handleToggleStyle(style.id)}
          >
            <h3>{style.title}</h3>
            <p>{style.description}</p>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginBottom: '2rem', color: 'var(--soft-gray)' }}>
        {selectedStyles.length === 0 && 'Select at least 1 style to continue'}
        {selectedStyles.length === 1 && 'You can select 1 more style'}
        {selectedStyles.length === 2 && 'Maximum 2 styles selected'}
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={selectedStyles.length === 0}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default StyleStep; 